import { RG_TYPE as s, DOOR_TYPE as V, RgCreate as Y, RgDefaults as _ } from "@project-rouge/rg-core";
import { applyInverseTransform as u } from "../../geometry-utils/core/index.js";
import { getPivot as A } from "../../geometry-utils/three/index12.js";
import { distanceToLine as F } from "../../geometry-utils/three/index18.js";
import { Vector3toV3 as m } from "../../geometry-utils/index10.js";
import { getDoorTypeFromId as G } from "../../utils/index14.js";
function K({ obj: E, point: g, type: r, rvDataList: c = void 0, modulousId: l = void 0, size: S = [1, 2, 0.15], isEntrance: h = void 0 }) {
  var R;
  if (![s.Opening, s.Wall, s.Door].includes(r))
    return;
  const a = E.children.filter((o) => o.type === s.Wall);
  if (a.length === 0)
    return;
  const p = a.map((o) => [
    m(A([0, 0, 0.5], o)),
    m(A([1, 0, 0.5], o))
  ]).map((o) => F(g, o));
  let z = p[0].distance, f = p[0].closest.toArray(), T = 0;
  for (let o = 0; o < p.length; o++) {
    const d = p[o];
    d.distance < z && (z = d.distance, f = d.closest.toArray(), T = o);
  }
  f[1] = m(g)[1];
  const W = r === s.Door && l ? G(l) : V.Misc, e = a[T], n = ((R = c == null ? void 0 : c.find((o) => o.modulousId === l)) == null ? void 0 : R.size) || S;
  r === s.Opening && (n[2] = e.size[2]);
  const t = [0.5, 0, 0.5], i = u(f, e), O = (1 - e.anchor[0]) * e.size[0] - e.size[0], w = e.anchor[0] * e.size[0], P = e.size[1], y = 0, x = i[0] - (1 - t[0]) * n[0], C = i[0] + t[0] * n[0], D = i[1] + (1 - t[1]) * n[1], I = i[1] - t[1] * n[1];
  x < O ? i[0] = O + (1 - t[0]) * n[0] : C > w && (i[0] = w - t[0] * n[0]), D > P ? i[1] = P - (1 - t[1]) * n[1] : I < y && (i[1] = y + t[1] * n[1]);
  const B = Y({
    ..._[r],
    size: n,
    pos: i,
    anchor: t,
    alpha: 0.5,
    ...l && { modulousId: l },
    ...r === s.Door && { data: { doorType: W, ...h && { isEntrance: h } } }
  }, c || []);
  return e.children.push(B), B;
}
export {
  K as addOpeningOnClosestPoint
};
//# sourceMappingURL=index.js.map
